import { render, staticRenderFns } from "./NozamaOrders.vue?vue&type=template&id=f906fb86&scoped=true"
import script from "./NozamaOrders.vue?vue&type=script&lang=js"
export * from "./NozamaOrders.vue?vue&type=script&lang=js"
import style0 from "./NozamaOrders.vue?vue&type=style&index=0&id=f906fb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f906fb86",
  null
  
)

export default component.exports